var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "artwork-size" },
    [
      _c(
        "tab-heading",
        _vm._g({ attrs: { "is-prev-disabled": true } }, _vm.$listeners),
        [
          _c("h2", { staticClass: "text-center" }, [_vm._v("Artwork Size")]),
          _c("p", { staticClass: "lead text-center mb-0" }, [
            _vm._v("Enter the size of the item you would like to frame:"),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "text-center my-4" },
        [
          _c("b-form-radio-group", {
            attrs: {
              options: _vm.sizeTypeOptions,
              buttons: "",
              "button-variant": "brand",
              size: "lg",
            },
            on: { change: _vm.onSizeTypeChange },
            model: {
              value: _vm.sizeType,
              callback: function ($$v) {
                _vm.sizeType = $$v
              },
              expression: "sizeType",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.sizeType == "bespoke",
              expression: 'sizeType == "bespoke"',
            },
          ],
          staticClass: "mb-5",
          attrs: { id: "bespoke-size-inputs" },
        },
        [
          _c(
            "b-row",
            { staticClass: "mb-3", attrs: { "align-h": "center" } },
            [
              _c(
                "b-col",
                { staticClass: "text-center", attrs: { md: "8" } },
                [
                  _c("unit-selector", {
                    model: {
                      value: _vm.displayUnit,
                      callback: function ($$v) {
                        _vm.displayUnit = $$v
                      },
                      expression: "displayUnit",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            { attrs: { "align-h": "center" } },
            [
              _c(
                "b-col",
                { attrs: { xl: "10" } },
                [
                  _c("size-input", {
                    attrs: {
                      unit: _vm.displayUnit,
                      size: "lg",
                      valid: _vm.areDimensionsValid,
                    },
                    model: {
                      value: _vm.artworkSize,
                      callback: function ($$v) {
                        _vm.artworkSize = $$v
                      },
                      expression: "artworkSize",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.sizeType == "standard",
              expression: 'sizeType == "standard"',
            },
          ],
          staticClass: "mb-5",
          attrs: { id: "standard-size-inputs" },
        },
        [
          _c(
            "b-row",
            { attrs: { "align-h": "center" } },
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("standard-size-selector", {
                    model: {
                      value: _vm.artworkSize,
                      callback: function ($$v) {
                        _vm.artworkSize = $$v
                      },
                      expression: "artworkSize",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-alert",
        { attrs: { variant: "danger", show: _vm.problems.length > 0 } },
        _vm._l(_vm.problems, function (problem, idx) {
          return _c("p", { key: idx, staticClass: "text-center mb-0" }, [
            _vm._v(_vm._s(problem) + " "),
          ])
        }),
        0
      ),
      _c(
        "b-alert",
        { attrs: { variant: "warning", show: _vm.warnings.length > 0 } },
        _vm._l(_vm.warnings, function (warning, idx) {
          return _c("p", { key: idx, staticClass: "text-center mb-0" }, [
            _vm._v(_vm._s(warning) + " "),
          ])
        }),
        0
      ),
      _c(
        "b-row",
        { staticClass: "my-4", attrs: { "align-h": "center" } },
        [
          _c("b-col", { staticClass: "border-left pl-4", attrs: { md: "6" } }, [
            _c("p", { staticClass: "lead pt-3" }, [
              _c("strong", [_vm._v("Unsure what size to enter?")]),
              _vm._v(" View our "),
              _c(
                "a",
                { attrs: { href: "/guide-to-picture-frame-measurements" } },
                [_vm._v("Picture Frame Measurements Guide")]
              ),
              _vm._v("."),
            ]),
            _c("p", { staticClass: "lead" }, [
              _vm._v(
                "If you require a frame made to an exact external size, please call or "
              ),
              _c("a", { attrs: { href: "mailto:sales@bramptonframing.com" } }, [
                _vm._v("e-mail"),
              ]),
              _vm._v(" us and we will be happy to help."),
            ]),
            _c("p", { staticClass: "text-muted" }, [
              _c("strong", [_vm._v("Please Note:")]),
              _vm._v(
                " the external sizes calculated on this online designer are approximations only."
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "my-4", attrs: { "align-h": "center" } },
        [
          _c(
            "b-col",
            {
              staticClass: "border-left border-primary pl-4",
              attrs: { md: "6" },
            },
            [
              _c(
                "p",
                { staticClass: "lead mb-0 py-3" },
                [
                  _vm._v("Want to see your artwork in a frame? "),
                  _c("strong", [
                    _vm._v("Enter your artwork dimension in the boxes above"),
                  ]),
                  _vm._v(" and then please click on the "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "danger", size: "sm" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("upload-image")
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons mr-1" }, [
                        _vm._v("upload_file"),
                      ]),
                      _vm._v("Upload Image"),
                    ]
                  ),
                  _vm._v(
                    " button to visualise your art in over 2000 frames and hundreds of windowmount options."
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }